import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { PedidoConsultaInternaOutput } from 'src/app/@shared/models/consulta-detalhes-interno';
import { GoogleMapsService } from 'src/app/services/google-maps/google-maps.service';
import { BlocoDetalhesInternosComponent } from '../../bloco-detalhes-internos.component';

@Component({
  selector: 'app-aba-foto-da-entrega',
  templateUrl: './aba-foto-da-entrega.component.html',
  styleUrls: ['./aba-foto-da-entrega.component.scss'],
})
export class AbaFotoDaEntragaComponent implements OnInit {
  static Title = 'Foto da entrega';
  static Concluido = (el: FormGroup) => {
    return true;
  };

  isLoadingStreetViewThumb: boolean = true;
  detalheStreetView: string;
  @Input('pedido') pedido: PedidoConsultaInternaOutput;
  @Input('Exibir') exibir: boolean = true;
  entregaUrl: string;
  @Input() parent: BlocoDetalhesInternosComponent;
  constructor(private mapsService: GoogleMapsService) {}

  ngOnInit() {
    this.loadLatLongFotoEntrega();
  }

  async loadLatLongFotoEntrega() {
    //buscar thumb pelo endereço do destinatário
    this.detalheStreetView = `${this.pedido.desEndereco} ${this.pedido.desBairro}, ${this.pedido.desMunicipio}-${this.pedido.desUF}, ${this.pedido.desCEP}`;
    this.entregaUrl = await this.mapsService.getStreetViewThumbnail(
      this.detalheStreetView,
      531,
      248
    );
    if (!this.entregaUrl && this.pedido.comprovantes?.length > 0) {
      //caso não localizar e possuir dados, buscar por latitude/longitude
      let valid_positions = this.pedido.comprovantes.filter(
        (c) => Number(c.latitude) > 0 && Number(c.longitude)
      );
      if (valid_positions && valid_positions.length > 0) {
        let lat_lng = valid_positions[0];
        this.detalheStreetView = lat_lng.latitude + ',' + lat_lng.longitude;
        this.entregaUrl = await this.mapsService.getStreetViewThumbnail(
          this.detalheStreetView,
          531,
          248
        );
      }
    }
    this.isLoadingStreetViewThumb = false;
  }
}
